import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { formatNumber } from '@angular/common';
import { isBoolean, isNumber } from '../utils/type-guards';

@Pipe({
  name: 'appHumanizeBoolean'
})
export class HumanizeBooleanPipe implements PipeTransform {
  #translate = inject(TranslateService);
  #locale = inject(LOCALE_ID);

  transform(value: any, placeholder: string = null): any {
    // true  false
    if (isBoolean(value))
      return this.#translate.instant(value ? 'general.yes_l' : 'general.no_l');
    // numbers (including 0)
    if (isNumber(value) && !isNaN(value))
      return formatNumber(value, this.#locale);
    // null undefined '' (empty string))
    if (!value)
      return this.#translate.instant(placeholder || 'NOT_AVAILABLE_L');
    // complex types
    if (typeof value !== 'string') return value;
    // others
    return this.#translate.instant(
      value || (placeholder ? placeholder : 'NOT_AVAILABLE_L')
    );
  }
}
